import { usePageTitle } from '../hooks/usePageTitle'
import AnnouncementBanner from '../components/AnnouncementBanner'
import Navbar from '../components/Navbar'
import Hero from '../components/Hero'
import TickerBand from '../components/TickerBand'
import ApplicableProducts from '../components/ApplicableProducts'
// import RevealSection from '../components/RevealSection'
import WhyJapanSection from '../components/WhyJapanSection'
import WhyBybeitySection from '../components/WhyBybeitySection'
import ServicesSection from '../components/ServicesSection'
import HowItWorksSection from '../components/HowItWorksSection'
import FAQSection from '../components/FAQSection'
import CTAStrip from '../components/CTAStrip'
import Footer from '../components/Footer'

export default function HomePage() {
  usePageTitle('Bybeit — Japan market entry for SaaS & AI startups', '')
  return (
    <>
      <AnnouncementBanner />
      <Navbar hasBanner />
      <main className="home-main">
        <Hero />
        <TickerBand />
        <ApplicableProducts />
        {/* <RevealSection /> */}
        <WhyJapanSection />
        <WhyBybeitySection />
        <ServicesSection />
        <HowItWorksSection />
        <FAQSection />
      </main>
      <CTAStrip bg="var(--home-bg)" />
      <Footer />
    </>
  )
}
